import { render, staticRenderFns } from "./Dropzone.vue?vue&type=template&id=b895e57a&scoped=true"
import script from "./Dropzone.vue?vue&type=script&setup=true&lang=js"
export * from "./Dropzone.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Dropzone.vue?vue&type=style&index=0&id=b895e57a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b895e57a",
  null
  
)

export default component.exports